import store from "../../../../../store";
import i18n from "../../../../../i18n";
import lodash from "lodash";
import { has } from "../../../../../utils/menu-context";
import { Col, notification, Row } from 'ant-design-vue';
import { useForm as createUseForm } from "@ant-design-vue/use";
import { setAppPageHeader } from "../../../../../components/layout/app-layout/app-layout.logic";
import { createAppPageHeaderTop } from "../../../../../utils/page";
import { required, validateError } from '../../../../../utils/validate';
import { setIsLoading as setIsLoadingApp } from "../../../../../app.logic";

import {
    initUseForm,
    onClickActive,
    onClickArchive,
    onClickCreate,
    onClickDelete,
    onClickEdit,
    onClickView,
    checkAttribute,
} from "../../../../../utils/form";

import {
    createFieldInput,
    createFieldSelect
} from "../../../../../components/input/template-builder/template-builder.logic";

import {
    getLabTopicByLabTypeKey
} from '../lab-share.logic';

import {
    createButtonActive, createButtonArchive,
    createButtonCreate, createButtonDelete,
    createButtonEdit,
    createButtonSave,
    createButtonView
} from "../../../../../utils/button";

import {
    actionPrefix,
    callActive,
    callSearch,
    routerPrefix,
    state
} from "./lab-physic-monitor-product-topic-method-list.logic";
import { createLoading } from '../../../../../utils/loading';

export const { isLoading, setIsLoading } = createLoading();

export const callSamplingMonitorProductGroup = ({ criteria }) => store.dispatch(`resource/v1/master/labMonitorProductGroup/search`, { criteria });


export const callSave = ({ form }) => store.dispatch(`${actionPrefix}/save`, { data: form });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, {
    id,
    config: { params: { isHardDelete: false } }
});
export const callProductType = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "PRODUCT_TYPE", value: searchQuery });


export const createFormTitle = ({ data }) => {
    return data.useForm?.modelRef?.id ? data.useForm.modelRef.name : i18n.global.t("button.create");
};


export const createSearchOneCriteria = ({ id, forLog }) => {
    if (!forLog) {
        return {
            select: ["**"],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
        }
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: 'id', type: 'UUID', operator: '=', value: id }],
            children: [],
        }
    }
}

export const onClickSave = async ({ data }) => {
    setIsLoadingApp(true);
    return data.useForm
        .validate()
        .then(() => {
            // data.useForm.modelRef.value = data.useForm.modelRef.key;
            const checkDuplicateCriteria = {
                page: 0,
                size: 1,
            }
            checkDuplicateCriteria.where = [
                { name: 'refLabMonitorProductGroup.id', type: "UUID", operator: '=', value: data.useForm?.modelRef?.refLabMonitorProductGroup?.id },
                { name: 'refLabTopic.id', type: "UUID", operator: '=', value: data.useForm?.modelRef?.refLabTopic?.id },
                { name: 'nameMethod', type: "String", operator: 'like', value: data.useForm?.modelRef?.nameMethod },
                { name: 'id', type: "UUID", isNot: true, operator: '=', value: data?.useForm?.modelRef?.id }
            ]
            return callSearch({ criteria: checkDuplicateCriteria }).then(res => {
                if (res.data.length > 0) {
                    notification['error']({ message: i18n.global.t("model.topicMethod.error.duplicate") });
                    setIsLoadingApp(false);
                    return
                }
                return callSave({ form: data.useForm.modelRef })
                    .finally(() => setIsLoadingApp(false))
                    .then((record) => onClickView({ record, routerPrefix }));
            })
        })
        .catch((error) => validateError({ error }));
};


export const createRules = () => {
    return {
        refLabTopic: [required],
        nameMethod: [required],
        refLabMonitorProductGroup: [required],
    };
};

export const createForm = () => {
    return {
        isSave: true,
        refLabTopic: null,
        nameMethod: null,
        refLabMonitorProductGroup: null,
    };
};



export const createAppPageHeaderDefault = ({ props, data }) => {
    const col1 = []
    const col2 = []
    const { menuContext, viewOnly } = props
    const { id, isActive } = data.useForm.modelRef
    if (id && has({ menuContext, key: 'canCreate' })) {
        col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: 'm-1' }))
    }
    if (!viewOnly && id && has({ menuContext, key: 'canView' })) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: 'm-1' }))
    }
    if (viewOnly && id && isActive && has({ menuContext, key: 'canEdit' })) {
        col1.push(createButtonEdit({ onClick: () => onClickEdit({ record: { id }, routerPrefix }), classStyle: 'm-1' }))
    }
    if (!viewOnly && (!id || (id && isActive))) {
        col1.push(createButtonSave({ onClick: () => onClickSave({ data }), classStyle: 'm-1' }))
    }
    if (viewOnly && id && !isActive && has({ menuContext, key: 'canActive' })) {
        col2.push(createButtonActive({ onClick: () => onClickActive({ record: { id }, callActive, setIsLoading: setIsLoadingApp, onClickEdit: () => onClickEdit({ record: { id }, routerPrefix }) }), classStyle: 'm-1' }))
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: 'canArchive' })) {
        col2.push(createButtonArchive({ onClick: () => onClickArchive({ record: { id }, callArchive, setIsLoading: setIsLoadingApp, onClickView: () => onClickView({ record: { id }, routerPrefix }) }), classStyle: 'm-1' }))
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: 'canDelete' })) {
        col2.push(createButtonDelete({ onClick: () => onClickDelete({ record: { id }, callDelete, setIsLoading: setIsLoadingApp, state, routerPrefix }), classStyle: 'm-1' }))
    }
    return <Row type="flex">
        <Col>{col1}</Col>
        <Col class="ml-auto">{col2}</Col>
    </Row>
}



export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return [
        createFieldSelect({
            key: `${prefix}refLabMonitorProductGroup`,
            colProp: () => ({ xs: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t("model.samplingMonitorType.modelName"),
            inputProp: () => {
                return {
                    value: model.refLabMonitorProductGroup,
                    "onUpdate:value": value => {
                        model.refLabMonitorProductGroup = value;
                    },
                    list: ({searchQuery}) => {
                        const criteria = {
                            select: ["**"],
                            page: 0,
                            size: 1000,
                            where: [{
                                name: 'refLabType.key', type: "String", operator: '=', value: 'labPhysic'
                            }]
                        }
                        if (searchQuery) {
                            criteria.where.push([{ name: 'name', type: "String", operator: 'like', value: searchQuery }])
                            criteria.where.push([{ name: 'code', type: "String", operator: 'like', value: searchQuery }])
                        }
                        return callSamplingMonitorProductGroup({criteria}).then(page => page.data)
                    },
                    optKey: "id",
                    renderLabel: ({ item }) => <div> { item.name }</div>,
                };
            },
            changeLog: { getValue: ({ record }) => record.refProductType?.value }
        }),
        createFieldSelect({
            key: `${prefix}refLabTopic`,
            colProp: () => ({ xs: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t("model.topicMethod.refLabTopic"),
            inputProp: () => ({
                value: model.refLabTopic,
                "onUpdate:value": value => model.refLabTopic = value,
                list: ({ searchQuery }) => getLabTopicByLabTypeKey({ searchQuery, labTypeKey: 'labPhysic' }).then(list => list.filter(it => it.refParent == null)),
                optKey: "id",
                optLabel: "name"
            }),
            changeLog: { getValue: ({ record }) => record.refLabTopic?.nameTh }
        }),
        createFieldInput({
            key: `${prefix}nameMethod`,
            colProp: () => ({ xs: 12 }),
            formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
            label: () => i18n.global.t("model.labMonitorProductGroupTopic.nameMethod"),
            inputProp: () => ({
                value: model.nameMethod,
                "onUpdate:value":
                    value => model.nameMethod = value,
                disabled: !model.refLabTopic || viewOnly
            })
        }),
    ];
};


export const initForm = ({ props, data, refs }) => {
    checkAttribute({ props, data, refs });
    data.form = createForm({ props, data, refs, isLoading });
    data.rules = createRules({ props, data, refs, isLoading });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, isLoading });
    loadForm({ props, data, refs })
        .then(() => {
            if (props.setAppPageHeader) {
                setAppPageHeader({
                    slots: {
                        top: () => createAppPageHeaderTop({
                            props,
                            data,
                            refs,
                            state,
                            routerPrefix,
                            onClickView,
                            onClickEdit
                        }),
                        default: () => createAppPageHeaderDefault({ props, data, refs })
                    }
                });
            }
        });
};


export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ id }) });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise
        .then(page => initUseForm({ props, data, refs, page, routerPrefix }))
        .finally(() => setIsLoading(false));
};


